{
  "version": 1,
  "asset_id": "7db2352f-0f0e-4df8-9445-9b703a079097",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/7db2352f-0f0e-4df8-9445-9b703a079097/sleeve-gastrectomy-es-v2-1536.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/7db2352f-0f0e-4df8-9445-9b703a079097/sleeve-gastrectomy-es-v2-1536.jpg",
  "original_filename": "sleeve-gastrectomy-es-v2-1536.jpg",
  "size": 166095,
  "content_type": "image/jpeg",
  "created_at": "2026-09-25T13:06:33Z"
}
